import React from 'react';

import Comments from 'four-nets/photoblog/posts/common/comments/comments';

import Buttons, { Props as ButtonsProps } from './buttons/buttons';

import CollectionImageSave from './collection-image-save/collection-image-save';

export interface Props {
    id: string;
    commentId?: string;
    onMore?: ButtonsProps['onMore'];
    likesCount?: number | null;
    inFeed?: boolean;
}

enum Mode {
    COMMENTS = 'COMMENTS',
    COLLECTIONS = 'COLLECTIONS',
}

interface State {
    mode: Mode;
}

class Controls extends React.PureComponent<Props, State> {
    state = { mode: Mode.COMMENTS };
    refMap = new Map<string, HTMLLIElement>();

    onAppear = (ref: HTMLLIElement | null, id: string) => {
        if (ref) {
            this.refMap.set(id, ref);
        } else {
            this.refMap.delete(id);
        }
    };

    toggleMode = () => {
        this.setState(prevState => {
            if (prevState.mode === Mode.COLLECTIONS) {
                return { mode: Mode.COMMENTS };
            } else {
                return { mode: Mode.COLLECTIONS };
            }
        });
    };

    focusComment(id: string) {
        const ref = this.refMap.get(id);

        if (ref) {
            const focus = () => {
                if (document.body.contains(ref)) {
                    if (document.activeElement === ref) {
                        ref.blur();
                        requestAnimationFrame(() => {
                            ref.focus();
                        });
                    } else {
                        ref.focus();
                    }
                } else {
                    requestAnimationFrame(focus);
                }
            };
            requestAnimationFrame(focus);
        }
    }

    componentDidMount() {
        if (this.props.commentId) {
            this.focusComment(this.props.commentId);
        }
    }

    render() {
        const { id, commentId, inFeed, ...rest } = this.props;
        const { mode } = this.state;
        return (
            <React.Fragment>
                <Buttons id={id} onSave={this.toggleMode} inFeed={inFeed} {...rest} />
                {mode === Mode.COMMENTS ? (
                    <Comments
                        variables={{ parentId: id }}
                        commentId={commentId}
                        onAppear={this.onAppear}
                        scrollOnNew={false}
                    />
                ) : mode === Mode.COLLECTIONS ? (
                    <CollectionImageSave
                        imageId={id}
                        onClose={() => {
                            this.setState({ mode: Mode.COMMENTS });
                        }}
                    />
                ) : null}
            </React.Fragment>
        );
    }
}

export default Controls;
